import { createFileRoute } from '@tanstack/react-router';
import { useLang } from '@/lib/LanguageContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';
import { LegalPageWrap } from '@/components/shared/LegalPageWrap';
import { LexiqueContent } from '@/components/sections/lexique-content';

// ═══════════════════════════════════════════════════════════
// /lexique — page SEO du Lexique AMG d'Océanne.
// Pendant routable du modal Lexique (LexiqueContent variant="page").
// Phase 27.81 refonte : dual modal+page pattern (cross-Intralys).
// Schema.org DefinedTermSet inclus dans LexiqueContent (page variant) ET
// injecté en SSR par le Worker (route-meta.ts + schema-org.ts).
//
// Phase 27.84 — lazy-load LexiqueContent. Le crawler reçoit DefinedTermSet +
// meta titre/description/canonical via le Worker AVANT que le chunk lazy
// arrive ; aucune régression SEO.
//
// Phase 27.84b — REVERT lazy-load. Le contenu DOIT être eager pour que les
// crawlers LLM (ChatGPT/Perplexity/Bing/etc.) qui ne rendent pas le JS voient
// le HTML complet. Le modal reste lazy (lexique-modal.tsx) pour la perf UX.
// ═══════════════════════════════════════════════════════════

export function LexiquePage() {
  const { lang } = useLang();
  const text = ta(t.lexique, lang);

  return (
    <LegalPageWrap
      eyebrow={text.eyebrow}
      title={text.title}
      intro={text.intro}
      maxWidth="max-w-3xl"
    >
      <LexiqueContent variant="page" />
    </LegalPageWrap>
  );
}

export const Route = createFileRoute('/lexique')({
  component: LexiquePage
});
